import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useIsDesktop } from "@/hooks/useBreakpoint";
import { subCategoryToLabel } from "@/utils/categoryHandler";
import { getSubCategoryImage } from "@/utils/marker";
export function SubcategoryCards({ gridColsClass, availableSubcategories, selectedSubCategories, toggleSubCategory, disabled, }) {
    const isDesktop = useIsDesktop(768);
    return (_jsx("div", { className: `grid ${gridColsClass} gap-4`, children: availableSubcategories.map((subcategoria) => {
            const isSelected = selectedSubCategories.includes(subcategoria);
            return (_jsxs("button", { id: `btn-subcategoria-${subcategoria
                    .toLowerCase()
                    .replaceAll("_", "-")}`, name: "subcategoria-evento", "data-testid": "event-subcategory-button", type: "button", disabled: disabled, onClick: () => toggleSubCategory(subcategoria), className: `
              ${disabled ? "" : "hover:bg-[#C2DEFE] cursor-pointer"}
              disabled:cursor-not-allowed
              rounded-lg
              flex
              ${isDesktop
                    ? "flex-row items-center p-4"
                    : "flex-col items-center justify-center p-2"}
              gap-3
              border-2
              transition-all
              shadow
              text-center
              ${isSelected
                    ? "bg-[#C2DEFE] border-[#C2DEFE]"
                    : "bg-[#EEF6FF] border-transparent"}
            `, children: [_jsx("img", { src: getSubCategoryImage(subcategoria), alt: subCategoryToLabel(subcategoria), className: "size-[4.5rem] object-contain shrink-0" }), _jsx("span", { className: `w-full text-center font-semibold break-words ${isDesktop ? "text-lg" : "text-xs"}`, children: subCategoryToLabel(subcategoria) })] }, subcategoria));
        }) }));
}
